module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/prospect/telecaller/telecaller-view/telecaller-view.component.css
// module id = ./src/app/prospect/telecaller/telecaller-view/telecaller-view.component.css
// module chunks = main